import { cn, getInitials } from '@/lib/utils'

const SIZES = {
  sm: 'h-8 w-8 text-[9px]',
  md: 'h-9 w-9 text-[10px]',
  lg: 'h-11 w-11 text-xs',
}

const INNER = {
  guest: 'bg-gradient-to-br from-primary/20 to-accent text-primary',
  therapist: 'bg-gradient-to-br from-gold/25 to-gold/10 text-[hsl(31_45%_38%)]',
  staff: 'bg-muted text-muted-foreground',
}

const RING = {
  guest: 'avatar-ring-guest',
  therapist: 'avatar-ring-therapist',
  staff: 'rounded-full bg-muted/80 p-[2px]',
}

export function AvatarChip({ name, size = 'md', variant = 'guest', className }) {
  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full shadow-sm',
        SIZES[size],
        RING[variant] ?? RING.guest,
        className,
      )}
    >
      <span
        className={cn(
          'flex h-[calc(100%-4px)] w-[calc(100%-4px)] items-center justify-center rounded-full font-bold',
          INNER[variant] ?? INNER.guest,
          size === 'sm' ? 'text-[9px]' : size === 'lg' ? 'text-xs' : 'text-[10px]',
        )}
      >
        {getInitials(name)}
      </span>
    </span>
  )
}
